import React from 'react';
import { Link } from 'react-router-dom';
import watermark2 from '../images /watermark2.png';

function About() {
  return (
    <div className="about-container">
      {/* Header Section */}
      <div className="about-header">
        <h1>About Us</h1>
        <p>Effortless Quote & Invoice Generation at Your Fingertips</p>
      </div>

      {/* Image Section */}
      <div className="watermark">
        <img src={watermark2} alt="Watermark" className="watermark-image" />
      </div>

      {/* Introduction */}
      <section className="about-content">
        <h2>What is Quotation/Invoice Generator?</h2>
        <p>
          Our Quotation/Invoice Generator is a streamlined tool designed to help
          businesses and individuals create professional and customized quotes
          and invoices quickly and efficiently. Whether you're a freelancer,
          small business owner, or enterprise, our tool eliminates manual errors
          and saves you time.
        </p>
      </section>

      {/* Features Section */}
      <section className="about-features">
        <h2>Why Choose Our Invoice Generator?</h2>
        <ul>
          <li>📌 Easy to Use – Enter your details and generate documents in seconds.</li>
          <li>📄 Customizable Quotes & Invoices – Tailor them to fit your brand and requirements.</li>
          <li>💾 Download & Save as PDF – Keep organized records for all transactions.</li>
          <li>🔐 Secure & Reliable – Your data is safe with us.</li>
        </ul>
      </section>

      {/* Step-by-Step Guide */}
      <section className="about-steps">
        <h2>How It Works</h2>
        <div className="steps-grid">
          <div className="step">
            <h3>1️⃣ Enter Details</h3>
            <p>Fill in required fields like item descriptions, quantities, rates, and any necessary customizations.</p>
          </div>
          <div className="step">
            <h3>2️⃣ Generate Quote/Invoice</h3>
            <p>Click the "Generate Quote/Invoice" button to create your professional document.</p>
          </div>
          <div className="step">
            <h3>3️⃣ Download & Share</h3>
            <p>Save your invoice as a PDF and send it to your client with ease.</p>
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section className="about-help">
        <h2>Need Assistance?</h2>
        <p>
          If you encounter any issues or have feedback, feel free to visit our
          <Link to="/help" className="help-link"> Help Page</Link>.
          We’re here to make your experience as smooth as possible!
        </p>
      </section>
    </div>
  );
}

export default About;
